/**
 * Marks a read that must not count as a record view.
 *
 * Invenio raises a view event whenever `/api/records/<id>` is read. That is
 * right for a member of the public opening a record page, and wrong for a
 * reviewer opening a submission or for the cache revalidating a record it is
 * already showing. Those callers send this header so the backend drops the
 * event instead of counting it.
 *
 * Keep the value in step with `STATS_OPT_OUT_VALUE` in
 * `invenio_vedra/stats.py`.
 */
export const STATS_OPT_OUT_HEADER = 'X-Vedra-Stats';

export const STATS_OPT_OUT_VALUE = 'off';

export const statsOptOutHeaders = (): Record<string, string> => ({
  [STATS_OPT_OUT_HEADER]: STATS_OPT_OUT_VALUE,
});
